// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Bfp_fullWidth__nVlWK","label":"Bfp_label__3rZfD","root":"Bfp_root__kz1rM","negative":"Bfp_negative__ajCWh"};